import { regex } from '../regex';

export const plural_rules = [

	// do not replace if its already a plural word
	[regex.plural.men],
	[regex.plural.people],
	[regex.plural.children],
	[regex.plural.tia],
	[regex.plural.analyses],
	[regex.plural.hives],
	[regex.plural.curves],
	[regex.plural.lrves],
	[regex.plural.foves],
	[regex.plural.aeiouyies],
	[regex.plural.series],
	[regex.plural.movies],
	[regex.plural.xes],
	[regex.plural.mice],
	[regex.plural.buses],
	[regex.plural.oes],
	[regex.plural.shoes],
	[regex.plural.crises],
	[regex.plural.octopi],
	[regex.plural.aliases],
	[regex.plural.summonses],
	[regex.plural.oxen],
	[regex.plural.matrices],
	[regex.plural.feet],
	[regex.plural.teeth],
	[regex.plural.geese],
	[regex.plural.quizzes],
	[regex.plural.whereases],
	[regex.plural.criteria],
	[regex.plural.genera],

	// original rule
	[regex.singular.man, '$1en'],
	[regex.singular.person, '$1ople'],
	[regex.singular.child, '$1ren'],
	[regex.singular.ox, '$1en'],
	[regex.singular.axis, '$1es'],
	[regex.singular.octopus, '$1i'],
	[regex.singular.alias, '$1es'],
	[regex.singular.summons, '$1es'],
	[regex.singular.bus, '$1ses'],
	[regex.singular.buffalo, '$1oes'],
	[regex.singular.tium, '$1a'],
	[regex.singular.sis, 'ses'],
	[regex.singular.ffe, '$1$2ves'],
	[regex.singular.hive, '$1ves'],
	[regex.singular.aeiouyy, '$1ies'],
	[regex.singular.matrix, '$1ices'],
	[regex.singular.vertex, '$1ices'],
	[regex.singular.x, '$1es'],
	[regex.singular.mouse, '$1ice'],
	[regex.singular.foot, 'feet'],
	[regex.singular.tooth, 'teeth'],
	[regex.singular.goose, 'geese'],
	[regex.singular.quiz, '$1zes'],
	[regex.singular.whereas, '$1es'],
	[regex.singular.criterion, '$1a'],
	[regex.singular.genus, 'genera'],

	[regex.singular.s, 's'],
	[regex.singular.common, 's'],
] as [RegExp, string?][];

export default plural_rules
